import React from 'react';

const DialogButtonGroup = ({ children, rounded = true }) => (
  <div className="ws-ui-dialog-button-group" data-rounded={rounded}>
    {children}
  </div>
);

export default DialogButtonGroup;
